module.exports = __webpack_public_path__ + "img/englishTeacher-sm.ef96dc07.png";